import React from "react";
import {
	IUserTrainingCourseSectionSummary,
	IUserTrainingCourseVideoSummary,
} from "src/@types/ImpiricaPlatformApi";
import TrainingSummaryVideo from "./TrainingSummaryVideo";
import styles from "./TrainingSummarySection.module.scss";

type TrainingSummarySectionProps = {
	section: IUserTrainingCourseSectionSummary;
};

const TrainingSummarySection: React.FC<TrainingSummarySectionProps> = ({
	section,
}) => {
	return (
		section && (
			<div className={styles.container}>
				<p className={styles.title}>{section.name}</p>
				{section.videos &&
					section.videos.map(
						(video: IUserTrainingCourseVideoSummary, index: number) => {
							return <TrainingSummaryVideo key={index} video={video} />;
						}
					)}
			</div>
		)
	);
};

export default TrainingSummarySection;
